// LiveChatLoader.jsx
import { useEffect } from "react";

export default function LiveChatLoader({ codeHtml /* string */ }) {
    // console.log(codeHtml);
    useEffect(() => {
        if (!codeHtml) return;

        const container = document.createElement('div');
        container.id = 'live-chat-container';
        // position small widget so it doesn't block page:
        Object.assign(container.style, {
            position: 'fixed',
            right: '20px',
            bottom: '20px',
            zIndex: '999', // below major modals
            pointerEvents: 'auto',
        });
        document.body.appendChild(container);

        // parse provided HTML and execute scripts safely
        const temp = document.createElement('div');
        temp.innerHTML = codeHtml;
        // move non-script nodes
        Array.from(temp.childNodes).forEach(node => {
            if (node.tagName && node.tagName.toLowerCase() === 'script') return;
            container.appendChild(node.cloneNode(true));
        });
        // execute scripts by creating new script tags (ensures execution)
        Array.from(temp.querySelectorAll('script')).forEach((oldScript, i) => {
            const s = document.createElement('script');
            Array.from(oldScript.attributes).forEach(a => s.setAttribute(a.name, a.value));
            s.text = oldScript.textContent;
            s.id = `live-chat-script-${Date.now()}-${i}`;
            container.appendChild(s);
        });

        // cleanup
        return () => {
            // best-effort provider-specific hide/destroy (if available)
            try { window.Tawk_API && window.Tawk_API.hideWidget && window.Tawk_API.hideWidget(); } catch { }
            try { window.$crisp && window.$crisp.push && window.$crisp.push(["do", "hide"]); } catch { }
            // remove container & script tags appended
            const el = document.getElementById('live-chat-container');
            if (el) el.remove();

            // remove globals
            ['Tawk_API', 'Tawk_LoadStart', 'Crisp', 'Intercom', 'zE', '__zopim', '$crisp'].forEach(k => {
                try { delete window[k]; } catch { }
            });
        };
    }, [codeHtml]);

    return null;
}
